function injectStyle (ssrContext) {
  require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7cd91093\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader?{\"globalVars\":{\"museUiTheme\":\"'/usr/src/app/node_modules/muse-ui/src/styles/themes/variables/default.less'\"}}!../../../vue-loader/lib/selector?type=styles&index=0!./flatButton.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./flatButton.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7cd91093\",\"hasScoped\":false}!../../../vue-loader/lib/selector?type=template&index=0!./flatButton.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/muse-ui/src/flatButton/flatButton.vue
// module id = 339
// module chunks = 1